// eslint-disable-next-line no-restricted-syntax
import * as SecureStore from 'expo-secure-store'; // https://docs.expo.dev/versions/latest/sdk/securestore/#usage
import { logBreadcrumb } from 'shared/utils/sentry/sentry';

const setItemSecureStore = async (key: string, value: string) => {
  try {
    await SecureStore.setItemAsync(key, value, {
      keychainAccessible: SecureStore.WHEN_UNLOCKED_THIS_DEVICE_ONLY,
    });
  } catch (error) {
    logBreadcrumb({
      level: 'error',
      message: 'SecureStore.setItemSecureStore' + error,
    });
  }
};

const getItemSecureStore = async (key: string) => {
  try {
    return await SecureStore.getItemAsync(key, {
      keychainAccessible: SecureStore.WHEN_UNLOCKED_THIS_DEVICE_ONLY,
    });
  } catch (error) {
    logBreadcrumb({
      level: 'error',
      message: 'SecureStore.getItemSecureStore' + error,
    });
  }
};

const deleteItemSecureStore = async (key: string) => {
  try {
    await SecureStore.deleteItemAsync(key, {
      keychainAccessible: SecureStore.WHEN_UNLOCKED_THIS_DEVICE_ONLY,
    });
  } catch (error) {
    logBreadcrumb({
      level: 'error',
      message: 'SecureStore.deleteItemSecureStore' + error,
    });
  }
};

export {
  deleteItemSecureStore,
  getItemSecureStore,
  SecureStore,
  setItemSecureStore,
};
